export type SituacaoCotacaoReferencia = "ATIVA" | "INATIVA";

export type FiltroSituacaoCotacao = "ATIVAS" | "INATIVAS" | "TODAS";

export const COTACOES_REFERENCIA_SORT_FIELDS = [
  "competencia",
  "moeda",
  "cotacao",
  "situacao",
  "cadastradaEm",
] as const;

export type OrdenarCotacoesReferenciaPor = (typeof COTACOES_REFERENCIA_SORT_FIELDS)[number];

export interface CotacaoReferenciaItem {
  id: string;
  competencia: string;
  moeda: { id: string; codigo: string; nome: string };
  cotacao: number;
  situacao: SituacaoCotacaoReferencia;
  referenciaAtual: boolean;
  cadastradaEm: string;
  cadastradaPor: string;
  situacaoAlteradaEm: string | null;
  situacaoAlteradaPor: string | null;
  situacaoJustificativa: string | null;
}

export interface ListaCotacoesReferencia {
  items: CotacaoReferenciaItem[];
  total: number;
}

export interface ListarCotacoesReferenciaParams {
  moedaId?: string;
  situacao?: FiltroSituacaoCotacao;
  sort?: { field: OrdenarCotacoesReferenciaPor; direction: "asc" | "desc" };
  page?: number;
  pageSize?: number;
}

export interface CadastrarCotacaoReferenciaBody {
  moedaId: string;
  competencia: string;
  cotacao: number;
}

export interface SituacaoCotacaoAlterada {
  id: string;
  situacao: SituacaoCotacaoReferencia;
}
